export enum LocalStorageType {
  LOCALE = 'locale',
  GA_CLIENT_ID = 'gaClientId',
  ANALYTICS_CLIENT_ID = 'analyticsClientId',
}
